// extracted by mini-css-extract-plugin
export var banner = "_p8-0";
export var settingRow = "_p8-2";
export var titleIcon = "_p8-1";